import React from 'react';
import { Navigate } from 'react-router-dom';
import LegalDocumentsPanel from '../components/LegalDocumentsPanel';
import SEO from '../components/SEO';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * /operator/legal — operator-only legal-folder page.
 *
 * Lists operator-level documents (club_id == null) by default. Operator
 * admins can pass `?scope=ALL` in the URL to flatten across all clubs.
 */
export default function OperatorLegalPage() {
  const { user, loading } = useAuth();
  const params = new URLSearchParams(window.location.search);
  const scope = params.get('scope');

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  }
  if (!user || !(user.is_admin || user.is_operator_admin)) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="container mx-auto px-4 py-8 max-w-5xl">
      <SEO title="Legal" description="Operator legal documents" url="/operator/legal" noindex />
      <LegalDocumentsPanel scope="operator" clubId={scope === 'ALL' ? 'ALL' : null} />
    </div>
  );
}
